// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'

$(function () {

  function isInView(elem) {
    return $(elem).offset().top - $(window).scrollTop() < $(elem).height();
  }

  $(window).on('scroll', function () {
    $(".visibility").each(function () {
      if (isInView($(this))) {
        $(this).addClass("active");
      }
    });
  });

});

function calculateForm1(){
  $('#form-dobbelen .acf-form-submit input[type="submit"]').prop("disabled", true);

  var dobbelen_result = $('.acf-fields').find("[data-name='dobbelen_result']").find(':input').val();

  var pet_token = 'Nee';
  var pet_token_value;

  var joker = 'Nee';

  if ($('.acf-fields').find("[data-name='use_pet_token']").find(':input').is(':checked')) {
    pet_token = 'Ja';
    joker = 'Nee';
    pet_token_value = $('.acf-fields').find("[data-name='use_pet_token_value']").find('label.selected > input[type="radio"]').val();
  }

  if ($('.acf-fields').find("[data-name='use_joker']").find(':input').is(':checked')) {
    joker = 'Ja';
    pet_token = 'Nee';
  }

  //var dobbelen_check = $('.acf-fields').find("[data-name='dobbelen_check']").find(':input').val();
  if ($('.acf-fields').find("[data-name='dobbelen_check']").find(':input').is(':checked')) {
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'form1Calculate',
        dobbelen_result: dobbelen_result,
        pet_token: pet_token,
        pet_token_value: pet_token_value,
        joker:joker,
      },
      method: 'POST',
      beforeSend: function() {
        $(".loading-spinner").show();
      },
      success: function (post_id) {
        $('.calculation-result').html(post_id);
        $('.calculation-error').html('');
        $('#form1Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
        animateValue('diceFake');
        $(window).off('beforeunload');
        $(".loading-spinner").hide();
      }
    });
  }
  else{
    $('.calculation-error').html('<p class="error">Je moet akkoord gaan.</p>');
    $('#form-dobbelen .acf-form-submit input[type="submit"]').prop("disabled", false);
  }
}

function animateValue(id){
  $('.calculation-result').addClass('active');
  var obj = document.getElementById(id);
  var current = parseInt(obj.innerHTML);
  setInterval(function(){
    current++;
    if ( current === 7 ){
      current = 1;
    }
    // Update the contents of the element
    obj.innerHTML = current;
  },50);
  setTimeout(function(){
    $('#diceFake').addClass('hidden');
    $('#diceTrue').removeClass('hidden').addClass('active');
  }, 4000);
  setTimeout(function(){
    $('.old-tile').addClass('active');
  }, 5000);
  setTimeout(function(){
    $('.new-tile').addClass('active');
  }, 6000);
  setTimeout(function(){
    $('.message').addClass('active');
  },7000);
  setTimeout(function(){
    $('.back').addClass('active');
  },8000);
}

$(document).ready(function(){

  //$('#form-dobbelen .acf-form-submit input[type="submit"]').prop("disabled", true);
  //$('#form-dobbelen .acf-form-submit').append('<input type="submit" id="calculate_form1" value="Dobbelen" class="calculate-btn btn btn--primary"/>');

  $('#form-dobbelen .acf-form-submit input[type="submit"]').click(function(e){
    e.preventDefault();
    calculateForm1();
  });

});

$('.acf-fields .front-hidden input').prop("disabled", true);




// WEBPACK FOOTER //
// ./resources/assets/js/app.js